/* ica-pdp.js — PDP behaviors + the 5 PDP BRDG events.
   Loaded on PDPs with `defer`. No jQuery, vanilla only.

   Responsibilities:
     1. Brand-viewed event firing on PDP page load (once, with payload).
     2. Gallery thumbnail tap-to-swap.
     3. TDS email-gate inline form (guest) OR direct-download wiring (logged-in).
     4. SDS download click → event.
     5. Sample modal open/close + form submit.
     6. Quantity stepper (checkout buy box).
     7. Sticky CTA bar IntersectionObserver.
     8. RFQ button click + sticky bar click → quote_requested event.
     9. Variant chip click → reflect into hidden id input (checkout mode).
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function fire(eventType, payload) {
    if (window.icaEvents && typeof window.icaEvents.fire === 'function') {
      window.icaEvents.fire(eventType, payload || {});
    } else {
      try {
        window.dispatchEvent(new CustomEvent('icaEventFired', {
          detail: { event_type: eventType, payload: payload || {} }
        }));
      } catch (e) { /* silent */ }
    }
  }

  function emailValid(v) {
    return !!v && /^\S+@\S+\.\S+$/.test(v);
  }

  ready(function () {
    var main = document.querySelector('.ica-pdp-main');
    if (!main) return;

    var product = {
      handle: main.getAttribute('data-product-handle'),
      gid: main.getAttribute('data-product-gid'),
      brand: main.getAttribute('data-product-brand'),
      brandHandle: main.getAttribute('data-product-brand-handle'),
      line: main.getAttribute('data-product-line'),
      industry: main.getAttribute('data-product-industry'),
      industryHandle: main.getAttribute('data-product-industry-handle'),
      commerceMode: main.getAttribute('data-commerce-mode') || 'rfq'
    };

    // ------------------------------------------------------------
    // 1. brand_viewed — fires once on PDP load.
    // ------------------------------------------------------------
    if (product.brand) {
      fire('brand_viewed', {
        brand: product.brand,
        brand_handle: product.brandHandle,
        product_handle: product.handle,
        product_gid: product.gid,
        source_page: 'pdp'
      });
    }

    // ------------------------------------------------------------
    // 2. Gallery thumbnail tap-to-swap
    // The main <img> carries both src AND srcset. srcset takes precedence
    // over src, so updating only src does NOT change the displayed image —
    // we must also update (or clear) srcset. Each thumb emits a per-image
    // srcset via data-full-srcset so the swapped main image stays responsive.
    // ------------------------------------------------------------
    var mainImg = document.querySelector('[data-ica-pdp-main-image]') || document.getElementById('ica-pdp-main-img');
    var thumbs = document.querySelectorAll('[data-ica-pdp-thumb], .ica-pdp-gallery-thumb');
    if (mainImg && thumbs.length) {
      function activateThumb(t) {
        var fullSrc = t.getAttribute('data-full-src') || t.getAttribute('data-src');
        var fullSrcset = t.getAttribute('data-full-srcset') || '';
        var alt = t.getAttribute('data-alt');
        if (!fullSrc) return;
        thumbs.forEach(function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-selected', 'false');
          other.removeAttribute('aria-current');
        });
        t.classList.add('is-active');
        t.setAttribute('aria-selected', 'true');
        t.setAttribute('aria-current', 'true');
        // Clear srcset BEFORE src so the browser doesn't re-resolve the
        // old candidates against the new src.
        mainImg.removeAttribute('srcset');
        mainImg.src = fullSrc;
        if (fullSrcset) mainImg.setAttribute('srcset', fullSrcset);
        if (alt) mainImg.alt = alt;
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          activateThumb(t);
        });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            activateThumb(t);
          }
        });
      });
    }

    // ------------------------------------------------------------
    // 3. TDS gate (guest) or direct-download (logged-in)
    // ------------------------------------------------------------
    var tdsDirect = document.getElementById('ica-pdp-tds-direct');
    if (tdsDirect) {
      // Logged-in customer — direct download, fire event.
      tdsDirect.addEventListener('click', function () {
        fire('tds_downloaded', {
          product_handle: product.handle,
          product_gid: product.gid,
          brand: product.brand,
          product_line: product.line,
          tds_file_url: tdsDirect.getAttribute('href')
        });
      });
    }

    var tdsBtn = document.getElementById('ica-pdp-tds-btn');
    var tdsAction = document.getElementById('ica-pdp-tds-action');
    var tdsGate = document.getElementById('ica-pdp-tds-gate');
    var tdsCancel = document.getElementById('ica-pdp-tds-cancel');
    var tdsSuccess = document.getElementById('ica-pdp-tds-success');
    var tdsEmail = document.getElementById('ica-pdp-tds-email');

    if (tdsBtn && tdsGate) {
      tdsBtn.addEventListener('click', function () {
        if (tdsAction) tdsAction.style.display = 'none';
        tdsGate.classList.add('is-active');
        setTimeout(function () { if (tdsEmail) tdsEmail.focus(); }, 10);
      });
    }
    if (tdsCancel && tdsGate) {
      tdsCancel.addEventListener('click', function () {
        tdsGate.classList.remove('is-active');
        if (tdsAction) tdsAction.style.display = '';
        if (tdsBtn) tdsBtn.focus();
      });
    }
    if (tdsGate) {
      tdsGate.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (tdsEmail && tdsEmail.value || '').trim();
        if (!emailValid(email)) {
          if (tdsEmail) tdsEmail.focus();
          return;
        }
        var tdsUrl = tdsGate.getAttribute('data-ica-tds-url') || '';

        fire('tds_downloaded', {
          product_handle: product.handle,
          product_gid: product.gid,
          brand: product.brand,
          product_line: product.line,
          email: email,
          tds_file_url: tdsUrl
        });

        tdsGate.classList.remove('is-active');
        var sEmail = document.getElementById('ica-pdp-tds-success-email');
        if (sEmail) sEmail.textContent = email;
        if (tdsSuccess) tdsSuccess.classList.add('is-active');

        // Open the PDF in a new tab so the buyer can read it inline.
        if (tdsUrl) {
          try { window.open(tdsUrl, '_blank', 'noopener'); } catch (e) { /* silent */ }
        }
      });
    }

    // ------------------------------------------------------------
    // 4. SDS download click → event
    // ------------------------------------------------------------
    var sdsLinks = document.querySelectorAll('[data-ica-event="sds_downloaded"]');
    sdsLinks.forEach(function (a) {
      a.addEventListener('click', function () {
        fire('sds_downloaded', {
          product_handle: product.handle,
          product_gid: product.gid,
          brand: product.brand,
          sds_file_url: a.getAttribute('href') || a.getAttribute('data-ica-sds-url') || ''
        });
      });
    });

    // ------------------------------------------------------------
    // 5. Sample modal
    // ------------------------------------------------------------
    var modal = document.getElementById('ica-pdp-sample-modal');
    if (modal) {
      var openBtns = document.querySelectorAll('[data-ica-open-sample]');
      var closeEls = modal.querySelectorAll('[data-ica-close-modal]');
      var sampleForm = document.getElementById('ica-pdp-sample-form');
      var formWrap = document.getElementById('ica-pdp-modal-form-wrap');
      var successWrap = document.getElementById('ica-pdp-modal-success');
      var lastFocus = null;

      function openModal() {
        lastFocus = document.activeElement;
        if (formWrap) formWrap.style.display = '';
        if (successWrap) successWrap.classList.remove('is-active');
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        setTimeout(function () {
          var nameField = document.getElementById('ica-pdp-sample-name');
          if (nameField) nameField.focus();
        }, 60);
      }
      function closeModal() {
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
      closeEls.forEach(function (b) { b.addEventListener('click', closeModal); });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-active')) closeModal();
      });
      if (sampleForm) {
        sampleForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var name = (document.getElementById('ica-pdp-sample-name').value || '').trim();
          var email = (document.getElementById('ica-pdp-sample-email').value || '').trim();
          if (!name || !emailValid(email)) {
            if (!name) document.getElementById('ica-pdp-sample-name').focus();
            else document.getElementById('ica-pdp-sample-email').focus();
            return;
          }
          fire('sample_requested', {
            product_handle: product.handle,
            product_gid: product.gid,
            brand: product.brand,
            name: name,
            email: email
          });
          if (formWrap) formWrap.style.display = 'none';
          if (successWrap) successWrap.classList.add('is-active');
          sampleForm.reset();
        });
      }
    }

    // ------------------------------------------------------------
    // 6. Quantity stepper (checkout buy box)
    // ------------------------------------------------------------
    var qtyInput = document.getElementById('ica-pdp-qty');
    var qtyDown = document.getElementById('ica-pdp-qty-down');
    var qtyUp = document.getElementById('ica-pdp-qty-up');
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        var v = parseInt(qtyInput.value, 10);
        if (!v || v < 1) qtyInput.value = 1;
      });
    }
    if (qtyDown) qtyDown.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    if (qtyUp) qtyUp.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    // ------------------------------------------------------------
    // 7. Sticky CTA bar IntersectionObserver
    // ------------------------------------------------------------
    var buyBox = document.getElementById('ica-pdp-buybox');
    var stickyBar = document.getElementById('ica-pdp-sticky');
    if (buyBox && stickyBar && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var rect = entry.boundingClientRect;
          var aboveViewport = rect.bottom < 0;
          if (!entry.isIntersecting && aboveViewport) {
            stickyBar.classList.add('is-active');
            document.body.classList.add('ica-pdp-sticky-on');
          } else {
            stickyBar.classList.remove('is-active');
            document.body.classList.remove('ica-pdp-sticky-on');
          }
        });
      }, { threshold: 0, rootMargin: '0px' });
      observer.observe(buyBox);
    }

    // ------------------------------------------------------------
    // 8. Quote-requested wiring — in-page CTA + sticky CTA
    // ------------------------------------------------------------
    document.querySelectorAll('[data-ica-event="quote_requested"]').forEach(function (a) {
      a.addEventListener('click', function () {
        fire('quote_requested', {
          product_handle: product.handle,
          product_gid: product.gid,
          brand: product.brand,
          product_line: product.line,
          industry: product.industry,
          cta_source: a.getAttribute('data-ica-cta-source') || 'in_page_buy_box'
        });
      });
    });

    // ------------------------------------------------------------
    // 9. Sticky-bar wiring
    // (Tier 1 #5.5, 2026-05-20) The sticky CTA is now "Add to Quote" on
    // every PDP. It carries data-ica-quote-add and is wired by
    // ica-quote.js's Add._wireExisting() at DOMContentLoaded — no proxy
    // needed here. The earlier #ica-pdp-sticky-add → form.submit proxy
    // was removed when the sticky bar stopped owning Add-to-Cart.
    // ------------------------------------------------------------
    var addForm = document.getElementById('ica-pdp-add-form');

    // ------------------------------------------------------------
    // 10. Variant chips → reflect into form id (checkout mode)
    // ------------------------------------------------------------
    var variantChips = document.querySelectorAll('.ica-pdp-variant-chip');
    if (variantChips.length && addForm) {
      variantChips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var group = chip.closest('.ica-pdp-variant-chips');
          if (!group) return;
          group.querySelectorAll('.ica-pdp-variant-chip').forEach(function (c) {
            c.classList.remove('is-active');
            c.setAttribute('aria-checked', 'false');
          });
          chip.classList.add('is-active');
          chip.setAttribute('aria-checked', 'true');
          // Note: actual variant resolution to product.variants[].id requires
          // a JSON of variants here. Phase 1 ships with default-title-only
          // products (per BLC9001 fixture data). Full variant resolution is
          // a Phase 2 enhancement when colour variants ship.
        });
      });
    }
  });
})();
